module.exports = __webpack_public_path__ + "static/rainbow-df21796712a07b84d13a1901f90f6475.jpg";